/* Product page extras: exact bundle pricing + swipeable gallery. Runs after theme.js. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';

    function pad(number, size) {
      var s = '000000000' + number;
      return s.substr(s.length - size);
    }

    function thousands(number, precision, thousand, decimal) {
      var value = (number / 100.0).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousand);
      var cts = parts[1] ? decimal + pad(parts[1], precision) : '';
      return dollars + cts;
    }

    switch ((fmt.match(placeholder) || [])[1]) {
      case 'amount_no_decimals': return fmt.replace(placeholder, thousands(cents, 0, ',', ''));
      case 'amount_with_comma_separator': return fmt.replace(placeholder, thousands(cents, 2, '.', ','));
      case 'amount_no_decimals_with_comma_separator': return fmt.replace(placeholder, thousands(cents, 0, '.', ','));
      case 'amount_with_space_separator': return fmt.replace(placeholder, thousands(cents, 2, ' ', ','));
      case 'amount_no_decimals_with_space_separator': return fmt.replace(placeholder, thousands(cents, 0, ' ', ''));
      default: return fmt.replace(placeholder, thousands(cents, 2, ',', '.'));
    }
  }

  function currentVariant(form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return null;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    var idInput = form.querySelector('[name="id"]');
    return variants.filter(function (v) {
      return String(v.id) === String(idInput && idInput.value);
    })[0] || variants[0] || null;
  }

  function repriceForm(form) {
    var wrap = form.querySelector('[data-bundles]');
    if (!wrap) return;
    var variant = currentVariant(form);
    if (!variant) return;

    var moneyFormat = wrap.getAttribute('data-money-format');

    wrap.querySelectorAll('[data-bundle]').forEach(function (bundle) {
      var qty = parseInt(bundle.getAttribute('data-quantity'), 10) || 1;
      var payFor = parseFloat(bundle.getAttribute('data-pay-for')) || 0;
      var discount = parseFloat(bundle.getAttribute('data-discount')) || 0;

      if (payFor <= 0) payFor = Math.round(qty * (1 - discount / 100) * 2) / 2;
      if (payFor <= 0) payFor = qty;

      var total = Math.round(variant.price * payFor);
      var compareUnit = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
      var compareTotal = compareUnit * qty;

      var priceEl = bundle.querySelector('[data-bundle-price]');
      var compareEl = bundle.querySelector('[data-bundle-compare]');

      if (priceEl) priceEl.textContent = formatMoney(total, moneyFormat);
      if (compareEl) {
        if (compareTotal > total) {
          compareEl.textContent = formatMoney(compareTotal, moneyFormat);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    });
  }

  function repriceAll() {
    document.querySelectorAll('[data-product-form]').forEach(repriceForm);
  }

  function initGallery(wrapper) {
    var main = wrapper.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(wrapper.querySelectorAll('[data-gallery-thumb]'));
    if (!main || thumbs.length < 2) return;

    var index = 0;
    thumbs.forEach(function (t, i) { if (t.classList.contains('is-active')) index = i; });

    function show(next) {
      if (next < 0) next = thumbs.length - 1;
      if (next > thumbs.length - 1) next = 0;
      index = next;

      var thumb = thumbs[index];
      main.src = thumb.getAttribute('data-full');
      main.srcset = '';
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');

      if (thumb.scrollIntoView) {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { index = i; });
    });

    var startX = 0;
    var startY = 0;
    var tracking = false;

    main.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    main.addEventListener('touchend', function (event) {
      if (!tracking) return;
      tracking = false;
      var touch = event.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      show(dx < 0 ? index + 1 : index - 1);
    }, { passive: true });

    var stage = wrapper.querySelector('.gallery__main');
    if (!stage) return;
    var nav = document.createElement('div');
    nav.className = 'gallery__nav';
    nav.innerHTML =
      '<button type="button" aria-label="Previous image" data-gallery-prev>&#8249;</button>' +
      '<button type="button" aria-label="Next image" data-gallery-next>&#8250;</button>';
    stage.appendChild(nav);

    nav.querySelector('[data-gallery-prev]').addEventListener('click', function () { show(index - 1); });
    nav.querySelector('[data-gallery-next]').addEventListener('click', function () { show(index + 1); });
  }

  function start() {
    repriceAll();
    document.querySelectorAll('[data-gallery]').forEach(initGallery);

    document.addEventListener('change', function (event) {
      if (event.target.closest('[data-product-form]')) setTimeout(repriceAll, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
  } else {
    setTimeout(start, 0);
  }
})();
